import { createAction } from '../../../core/helpers'

import { FETCH_LOCATION_TYPE } from '../action-types'

export const cleanupFetchLocationType = createAction(
  FETCH_LOCATION_TYPE.CLEANUP,
)
